<template>
	<div>
		<div class="page-artist-filter mb-15">
			<a class="click--gold"
					@click="tabs = 'all'">
				{{ buttonTerm }}
			</a>
			<a class="click--gold"
					v-for="term in terms"
					@click="tabs = term.slug">
				{{ term.name }}
			</a>

		</div>
		<div class="row narrow">
			<div class="col-xs-6 col-sm-4 col-md-3 mb-15"
				 v-for="artist in filteredArtists">
				<div class="white-box">
					<a :href="artist.url" class="card__image"
					   :style='{"background-image": "url(" + artist.thumbnail +")"}'>
						<div class="card__hover" v-if="artist.subTitle">
							{{artist.subTitle}}
						</div>
					</a>
					<div class="card__content">
						<h3>
							<a :href="artist.url">{{artist.title}}</a>
						</h3>
						<p>
							{{artist.description}}
						</p>
						<a :href="artist.url"
						   class="link--gold">{{buttonArtist}}</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'artist',

		props: {
			posts:        {
				required: true,
        default: []
			},
			terms:        {
				required: true
			},
			buttonArtist: {
				required: true
			},
			buttonTerm:   {
				required: true
			}
		},

		data() {
			return {
				tabs: 'all'
			};
		},

		computed: {
			filteredArtists() {
				return this.posts.filter(post => {
					if(this.tabs === 'all') {
						return post;
					} else {
						return post.terms.includes(this.tabs);
					}
				});
			}
		}

	};
</script>
